<a *ngIf="value" target="_private" [href]="partialUrl">
  <qr-code
    [value]="url"
    [size]="config?.Size"
  ></qr-code>
</a>
